import React from "react";
import "./Radio.scss";

export interface RadioProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  checked: boolean;
  name?: string;
  disabled?: boolean;
  className?: string;
}

function Radio({
  onChange,
  value,
  checked,
  name = "custom-radio",
  disabled = false,
  className = "",
}: RadioProps): React.JSX.Element {
  const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (checked) {
      onChange({
        ...e,
        target: { ...e.target, value, checked: false },
      } as React.ChangeEvent<HTMLInputElement>);
    } else {
      onChange(e);
    }
  };
  return (
    <label className={`shared-radio ${className}`}>
      <input
        type="checkbox"
        name={name}
        className="radio-hidden"
        value={value}
        checked={checked}
        onChange={handleClick}
        disabled={disabled}
      />
      <div className={`radio-wrapper ${checked ? "checked" : ""}`}>
        {checked && <div className="radio-dot" />}
      </div>
    </label>
  );
}

export default Radio;
